import React, { useState } from "react";
import { Icon, Dropdown, DropdownToggle, DropdownMenu, LinkList, LinkListItem, Input } from 'design-react-kit'
import { fetchFromBFF } from '../utility/bffUtility';

export default function SwitchInButton() {

    const [email, setEmail] = useState("");

    async function switch_user() {
        await fetchFromBFF(`switch_user?email=${encodeURIComponent(email)}`).then(() => {
            location.href = "";
        });
    }

    return (
        <Dropdown className="me-3" style={{ width: 100 }}>
            <DropdownToggle caret color="primary">
                <Icon className='me-2' color='white' icon='it-exchange-circle' size='xs' />
                <span>Switch</span>
            </DropdownToggle>
            <DropdownMenu>
                <LinkList>
                    <LinkListItem inDropdown href='#' style={{ width: 300 }}>
                        <Input
                            style={{ marginTop: 30 }}
                            id="input_email"
                            label="Email"
                            placeholder=""
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </LinkListItem>
                    <LinkListItem inDropdown href='#'>
                        <span onClick={() => switch_user()}>Conferma</span>
                    </LinkListItem>
                </LinkList>
            </DropdownMenu>
        </Dropdown>
    )
}